module.exports = __webpack_public_path__ + "img/Frame 1071seven.60a0521c.png";